import TrackingPlugin from '@/helpers/tracking-plugin';
import { initPartytown } from '@/init/partytown';

export const initTracking = ({ app }) => {
  if (import.meta.env.NODE_ENV === 'production'
    && [
      'app.datapeople.io',
      'sandbox.datapeople.io',
      'test-app.taprecruit.co',
    ].includes(window.location.hostname)
    && !window.navigator.userAgent.endsWith('AWS-Canary-Noscript')
  ) {
    initPartytown();
    app.use(TrackingPlugin);
  }
};
